import {
    Http
} from '@/model/Http.js'
import { getToken, getUserUUID } from '@/utils/auth'
import store from '@/store'
import router from '@/router'
import { Message } from 'view-design'

export default class pay extends Http{
  getAlipayHtml(data){

    const url = 'api/yl/pay?money='+data.money+'&recordId='+data.recordId+'&type='+data.type
    return this.$axios.post(`${this.host}${url}`, data,{
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "x-token": getToken(),
          "uuid": getUserUUID()
        }
    })
  }

  updatePackage(data){
    const url = 'api/package/upgrade'
    return this.postAjax(url, data)
  }
  payForPackage(data){
    const url = 'api/package/go/open'
    return this.postAjax(url, data)
  }
  continuePackage(data){
    const url = 'api/package/go/continue'
    return this.postAjax(url, data)
  }
  payProfit(data){
      const url = 'api/package/go/pay-profit'
      return this.postAjax(url, data)
  }

  // 查询支付结果
  getPayStatus(data){
    const url = 'api/package/get-status'
    return this.postAjax(url, data)
  }

  // 微信h5查询支付结果
  getPayStatusByH5(data){
    const url = 'api/pre/package/get-status'
    return this.postAjax(url, data)
  }
  // 首信易支付
  sxyPay(data){
    const url = 'api/kk/pay'
    return this.postAjax(url, data)
  }
  // 公众号主页提现
  getWithdrawDetail(data){
    const url = 'api/shouto-platform-withdraw/get-withdraw-detail'
    return this.postAjax(url, data)
  }
  // 添加银行卡
  addBankCard(data,isOfficial){
    if(isOfficial){
      const url = 'api/open-bank-card-info/add'
      return this.postAjax(url, data)
    }else {
      const url = 'api/bank-card-info/add'
      return this.postOpenAjax(url, data)
    }
  }
  // 获取银行卡列表
  getBankCardList(data,isOfficial){
    // 判断是否公众号的提现还是推广位的提现
    if(isOfficial){
      const url = 'api/open-bank-card-info/bank-list'
      return this.postAjax(url, data)
    }else {
      const url = 'api/bank-card-info/bank-list'
      return this.postOpenAjax(url, data)
    }
  }
  // 删除银行卡
  deleteBankCard(data,isOfficial){
    // 判断是否公众号的提现还是推广位的提现
    if(isOfficial){
      const url = 'api/open-bank-card-info/delete'
      return this.postAjax(url, data)
    }else {
      const url = 'api/bank-card-info/del'
      return this.postOpenAjax(url, data)
    }
  }
  // 首信易提现
  sxyWithdraw(data){
    const url = 'api/shouto-platform-withdraw/withdraw'
    return this.postAjax(url, data)
  }
  // 支付宝提现
  zfbWithdraw(data){
    const url = 'api/shouto-platform-withdraw/add'
    return this.postAjax(url, data)
  }
  // 获取手机号码换绑银行卡
  getCode(data){
    const url = 'api/shouto-platform-withdraw/getCode'
    return this.postAjax(url, data)
  }
  // 推广位充值
  recharge(data){
    const url = 'api/open-recharge/sxy-recharge'
    return this.postOpenAjax(url, data)
  }
  // 获取我的银行卡
  getMyBankCardList(data){
    const url = 'api/bank-card-info/search'
    return this.postOpenAjax(url, data)
  }
  // 查询订单记录
  getPayOrderList(data){
    const url = 'api/open-recharge/sxy-query'
    return this.postOpenAjax(url, data)
  }
  // 推广位的首信易提现
  openSxyWithdraw(data){
    const url = 'api/withdraw/withdraw-kk'
    return this.postOpenAjax(url, data)
  }
  // 分销自动识别开户行
  recognitionBank(data){
    const url = 'api/pre/shouto-bank-card-info/distinguish'
    return this.postAjax(url, data)
  }
  // 推广位自动识别开户行
  openRecognitionBank(data){
    const url = 'api/bank-card-info/distinguish'
    return this.postOpenAjax(url, data)
  }
  // 推广位获取提现限制
  openGetLimit(data){
    const url = 'api/withdraw/get-withdraw-info'
    return this.postOpenAjax(url, data)
  }
  // 推广位那边是否使用首信易支付
  openIsSxy(data){
    const url = 'api/open-recharge/sxy-open'
    return this.postOpenAjax(url, data)
  }
  // 获取充值二维码
  changeAlipayQrcode(data){
    const url = 'api/open-recharge/kk-recharge'
    return this.postOpenAjax(url, data)
  }
  // 淘宝获取价格
  getPriceTb(data){
    const url = 'yp-api/movie/discount-rule/rate-price-cinema'
    return this.postAjaxByTb(url, data)
  }
  // 淘宝下单
  createOrder(data){
    const url = 'api/movie-taobao/movie-taobao-create'
    return this.postOpenAjax(url, data)
  }
  getCinema(data){
    const url = 'movieapi/movie-info/cinema/query'
    return this.postOpenAjax(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/pay.js